import styled from '@emotion/styled'
import { FlexBox } from 'app/components/Layout/FlexBox'
import React, { memo } from 'react'
import Fade from 'react-reveal/Fade'

import { Syncrobox } from './Syncrobox'

export interface Props {
  IBEID?: number
  languageCode: string
  languagePrefix: string
  benefitsTitle?: string
  benefitsChecklist?: string[]
  modalStatus?: boolean
}

export const ModalIBE = memo(function ModalIBE({
  IBEID,
  languageCode,
  languagePrefix,
  benefitsChecklist,
  benefitsTitle,
  modalStatus,
}: Props) {
  return (
    <Container row>
      <Fade right delay={250} duration={500} when={modalStatus}>
        <LeftSide dial={4}>
          <Benefits>
            {benefitsTitle ? <Title>{benefitsTitle}</Title> : null}
            {benefitsChecklist
              ? benefitsChecklist.map((item: any, index) => (
                  <Benefit key={index}>{item.benefit}</Benefit>
                ))
              : null}
          </Benefits>
        </LeftSide>
      </Fade>
      <Fade right duration={500} when={modalStatus}>
        <RightSide dial={5}>
          <Wrap>
            {IBEID ? (
              <Syncrobox
                IBEID={IBEID}
                languageCode={languageCode}
                languagePrefix={languagePrefix}
              />
            ) : null}
          </Wrap>
        </RightSide>
      </Fade>
    </Container>
  )
})

const Container = styled(FlexBox)`
  width: 72.5%;
  height: 100%;
  position: relative;
  z-index: 2;
  .react-reveal {
    width: 65%;
    height: 100%;
    &:first-of-type {
      width: 35%;
    }
  }

  @media (max-width: 1439px) {
    width: 85%;
  }
`

const LeftSide = styled(FlexBox)`
  height: 100%;
  background: ${({ theme }) => theme.colors.variants.primaryLight1};
  padding: 4.625rem 5.139vw;
  position: relative;
  &:before {
    content: '';
    width: 100%;
    height: 100%;
    background: url('/wave.svg') no-repeat center;
    background-size: cover;
    opacity: 0.16;
    position: absolute;
    top: 0;
    left: 0;
  }
`

const Benefits = styled.div``

const Title = styled.div`
  max-width: 172px;
  color: ${({ theme }) => theme.colors.variants.neutralLight4};
  font-family: ${({ theme }) => theme.fontFamily.heading};
  font-size: 1.375rem;
  line-height: 1.875rem;
  margin-bottom: 3rem;
`

const Benefit = styled.div`
  color: ${({ theme }) => theme.colors.variants.neutralLight4};
  font-family: ${({ theme }) => theme.fontFamily.paragraph};
  font-size: 0.9375rem;
  line-height: 22px;
  margin-bottom: 1.5rem;
  padding-left: 1rem;
  position: relative;
  &:last-of-type {
    margin-bottom: 0;
  }
  &:before {
    content: '';
    width: 0.375rem;
    height: 0.375rem;
    background: ${({ theme }) => theme.colors.variants.neutralLight4};
    border-radius: 50%;
    position: absolute;
    top: 0.5rem;
    left: 0;
  }
`

const RightSide = styled(FlexBox)`
  height: 100%;
  background: ${({ theme }) => theme.colors.variants.neutralLight3};
`

const Wrap = styled.div`
  margin: 0 auto;
  padding: 6rem 6.667vw;
`
